import { create } from 'zustand';
import { resetFocusSectionDonation } from './common';
import queryString from 'query-string';

interface DonationNavStore {
    step: number;
    nextStep: () => void;
    prevStep: () => void;
    initializeDonationStep: () => void;
}

const updateStepParams = (newStep: number, reset = false): void => {
    const url = window.location;

    const parsedParams = queryString.parse(url.search);

    parsedParams.step = newStep.toString();

    let newUrl = '';

    if (reset) {
        const newQueryString = queryString.stringify({ step: newStep });
        newUrl = `${url.pathname}?${newQueryString}`;
    } else {
        newUrl = queryString.stringifyUrl({
            url: url.href,
            query: { ...parsedParams },
        });
    }

    window.history.replaceState({}, '', newUrl);
};

export const useDonationNavigation = create<DonationNavStore>((set, get) => {
    return {
        step: 1,
        nextStep: (): void => {
            const nextStep = get().step + 1;

            updateStepParams(nextStep, true);

            set(() => {
                return { step: nextStep };
            });

            resetFocusSectionDonation();
        },
        prevStep: (): void => {
            const prevStep = get().step - 1;

            updateStepParams(prevStep);

            set(() => {
                return { step: prevStep };
            });
        },
        initializeDonationStep: (): void => {
            const parsedQueryUrl = queryString.parse(window.location.search);

            if (parsedQueryUrl?.token && parsedQueryUrl?.PayerID) {
                set({ step: 2 });
            }

            if (parsedQueryUrl?.step) {
                const queryStep = parseInt(parsedQueryUrl.step as string);

                if (queryStep && !isNaN(queryStep) && queryStep <= 3) {
                    set({ step: queryStep });
                } else {
                    set({ step: 1 });
                }
            }
        },
    };
});
